const state = {
  keepAliveInclude: []
};

const mutations = {
  SET_KEEP_ALIVE: (state, keepAliveInclude) => {
    state.keepAliveInclude = keepAliveInclude;
  }
};

const actions = {
  GET_KEEP_ALIVE: ({ commit }, data) => {
    commit("SET_KEEP_ALIVE", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
